export default __webpack_public_path__ + "static/media/vehicle.6ccee78e.svg";